import React, { useEffect } from 'react'
import Aboutus_banner from './aboutus_banner/Aboutus_banner'
import Aboutus_platform from './aboutus_platform/Aboutus_platform'
import This_keeps_up from './this_keeps_up/This_keeps_up'
import Trusted_platform from './trusted_platform/Trusted_platform'
import Our_team from './our_team/Our_team'
import Download_app from '../home/download_app/Download_app'
import { useLocation } from 'react-router-dom'


export default function AboutUs() {
    const location = useLocation();
    // Scroll to the top when the component mounts
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    return (
        <>
            <Aboutus_banner />
            <Aboutus_platform />
            <This_keeps_up />
            <Trusted_platform />
            <Our_team />
            <Download_app />
        </>
    )
}
